import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://xkxsqzfpnulhrsngokes.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhreHNxemZwbnVsaHJzbmdva2VzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY0NTE4NTMsImV4cCI6MjA3MjAyNzg1M30.eKmlrS3YNRrjMI4oJ8ETCGerOjGkSNTrd6tRrU15Q8g'

// Use anon key for client-side operations (auth, etc.)
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

export const SUPABASE_PAGE_SIZE = 2000;

// This is needed for migrations that need to retrieve from users metadata  (DONT COMMIT THE KEY PLEASE)
// Must be a non empty string
const supabaseServiceKey = 'invalid-key'
// Use service key for server-side operations (if needed)
export const supabaseAdmin = createClient(supabaseUrl, supabaseServiceKey)